import { Typography } from '@mui/material';
import React from 'react';

const Pay = () => {
    return (
        <div>
            <Typography variant='h4' style={{ color: '#18A3DD', fontWeight: 'bold', margin: '20px' }}>Payment Coming Soon</Typography>
        </div>
    );
};

export default Pay;